import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useQuery, gql } from "@apollo/client";

const ME_QUERY = gql`
  query ME {
    me {
      id
      roles
      permissionList
    }
  }
`;

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const { data, loading, error, refetch } = useQuery(ME_QUERY, {
    fetchPolicy: "network-only",
    skip: typeof window === "undefined", // SSR safety if needed
  });

  const me = data?.me || null;

  // permission Set for O(1) checks
  const permissionSet = useMemo(() => new Set(me?.permissionList || []), [me]);

  const value = {
    me,
    loading,
    error,
    permissionSet,
    refetchMe: refetch,
    hasLoaded: !loading && !!me,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
  return ctx;
};
